import React, { Component } from 'react';
import {
  Container,
  Input,
  Label,
  Row,
  Col,
  Button
} from 'reactstrap';

class SearchFooter extends Component {

  render() {
    return (
      <Container fluid id="searchFooter">
        <Row className='my-3 text-center'>
          <Col className="text-left">
          </Col>
          <Col className='text-center' md={3}>
            <Button
              key="buttonReset"
              color="secondary"
              onClick={this.props.handleReset}
            >Reset</Button>&nbsp;
            <Button
              key="buttonSubmit"
              color="primary"
              onClick={this.props.handleSubmit}
            >Search</Button>

          </Col>
          <Col className='text-left'>
            <Label check>
              <Input
                type="checkbox"
                name="showAll"
                checked={this.props.showAll}
                onChange={this.props.setShowAll}
              /> Show All Results (up to {this.props.pageSizeOptions.slice().pop()})
            </Label>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SearchFooter;